import { ChatMetric } from '../enums/chat-metric';

const { COLUMN_PADDING, COMPOSER_INSET, LOG_GUTTER, PIN_OFFSET } = ChatMetric;

/*
  How far an empty screen holds its greeting above the fold. A share of the viewport rather than a
  length, so the greeting sits in the same place on a laptop as on a monitor.
*/
const EMPTY_LIFT = '20dvh';

/**
 * ChatScreenUtil - I compose the lengths the reading column's boxes are given. ONLY concerned with
 * the arithmetic: `100cqh` is the scroll region's own height, so every measurement here is against
 * the column rather than the window, and nothing here reads the DOM or decides what is on screen.
 */
export const ChatScreenUtil = {
  /** The gap under the column: the composer's inset, or room to lift a greeting off the fold. */
  bottomInset({ hasChat }: { hasChat: boolean }) {
    return hasChat ? COMPOSER_INSET : `calc(${COLUMN_PADDING} + ${EMPTY_LIFT})`;
  },

  /**
   * A screen of room under the last turn, so a prompt pinned to the top has somewhere to scroll to.
   *
   * **The composer is not subtracted**, though it covers the end of the column: its height is the
   * region's business and changes as a prompt wraps, so taking it off here would both reach into
   * the region and resize every last turn while the reader types. The reserve is that much too
   * generous instead, which reads as a little more room under the final answer.
   */
  roomForAnAnswer() {
    return `calc(100cqh - (${LOG_GUTTER} + ${COMPOSER_INSET} + max(${COLUMN_PADDING}, ${PIN_OFFSET})))`;
  },

  /** The column less its own padding - at least a screen, so the composer is pushed to the bottom. */
  screen({ hasChat }: { hasChat: boolean }) {
    return `calc(100cqh - ${COLUMN_PADDING} - ${ChatScreenUtil.bottomInset({
      hasChat,
    })})`;
  },
};
